<script setup>
import { ref } from 'vue';
import { useLayoutStore } from '@/stores/layout.store.js';
import { useDisplay } from 'vuetify';

const props = defineProps({
  open: {
    type: Boolean,
    default: true
  },
  color: {
    type: String,
    default: '#fff'
  },
  width: {
    type: Number,
    default: 263
  },
  rail: {
    type: Boolean,
    default: false
  },
  railWidth: {
    type: Number,
    default: 56
  }
});

const { mobile } = useDisplay();
const navigationSideBar = computed({
  get() {
    return useLayoutStore().navigationSideBar;
  },
  set(value) {
    useLayoutStore().navigationSideBar = value;
  }
});

watchEffect(() => {
  useLayoutStore().navigationSideBar = mobile && navigationSideBar.value;
});
</script>

<template>
  <v-navigation-drawer
    id="navbar"
    :width="width"
    v-model="navigationSideBar"
    order="1"
    :color="color"
    :rail="rail"
    :rail-width="railWidth"
    :permanent="!mobile"
  >
    <div class="px-2">
      <slot />
    </div>
  </v-navigation-drawer>
</template>
